<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="businessDetailSeckillInfo.seckills" border style="width: 100%">
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <el-image 
              style="width: 50px; height: 50px; border-radius: 10px;"
              :src="scope.row.coverPhoto" 
              :preview-src-list="[scope.row.coverPhoto]"
              fit="cover">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" label="产品名称" align="center"></el-table-column>
        <el-table-column label="秒杀时段" align="center">
          <template slot-scope="scope">
            {{ formatPeriod(scope.row.killStartTime, scope.row.killEndTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" label="有效期内购买" align="center"></el-table-column>
        <el-table-column prop="oneCount" label="一次购买数量" align="center"></el-table-column>
        <el-table-column label="秒杀金额" align="center">
          <template slot-scope="scope">￥{{scope.row.killPrice}}</template>
        </el-table-column>
        <el-table-column label="单买金额" align="center">
          <template slot-scope="scope">￥{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column prop="killStock" label="限量" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.state == '1001'?'开启':'关闭'}}
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center">
          <template slot-scope="scope">
            {{scope.row.startTime}}~{{scope.row.endTime}}
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8"></el-col>
        <el-col :span="16" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businessDetailSeckillInfo: {
      type: Object,
      default: () => ({
        seckills: [],
        link: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('page-change', val, this.pageSize)
    },
    formatPeriod(killStartTime, killEndTime) {
      return this.toPickerTime(killStartTime) + '-' + this.toPickerTime(killEndTime)
    },
    toPickerTime(time) {
      if (!time) return '--:--'
      const parts = String(time).split(':')
      return `${String(parseInt(parts[0], 10)).padStart(2, '0')}:${String(parseInt(parts[1] || '0', 10)).padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}
.text-right {
  text-align: right;
}
</style>